'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isReactComponent = require('./isReactComponent');

var _isReactComponent2 = _interopRequireDefault(_isReactComponent);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Retrieves the name of a given React component.
 * @param {React.Component} Component A React component.
 * @returns {string} The name of the React component.
 */


function getComponentName(Component) {
  if (!(0, _isReactComponent2.default)(Component)) return '';
  return Component.displayName || Component.name || 'Component';
}

exports.default = getComponentName;